/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import AppVersion from '../../../client/js/components/AppVersion'
import ButtonGroup from '../../../client/js/components/form/ButtonGroup'
import FormField from '../../../client/js/components/form/fields/FormField'
import FormSubmitButton from '../../../client/js/components/form/buttons/FormSubmitButton'
import PageTitle from '../../../client/js/components/PageTitle'
import useQueryParams from '../../../client/js/hooks/useQueryParams'
import {
  createFieldInitializer,
  createFieldValidator,
  createFormValidator
} from '../../../client/js/lib/form'
import { postUpdatePassword } from '../lib/passwordAPIClient'
import UpdatePasswordFormSchema from '../schemas/UpdatePasswordFormSchema.mjs'
import { getPasswordResetLink, getPasswordResetSuccessLink } from '../lib/passwordLinks'
import { Box, Card, PasswordInput, Stack, Text } from '@mantine/core'
import AnchorLink from '../../../client/js/components/AnchorLink'
import { useNavigate } from 'react-router'
import SmartForm from '../../../client/js/components/form/SmartForm'
import useCustomForm from '../../../client/js/hooks/useCustomForm'
import Page from '../../../client/js/components/Page'

function UpdatePasswordFormPage () {
  const intl = useIntl()
  const navigate = useNavigate()

  const [params] = useQueryParams()
  const { requestId } = params
  const form = useCustomForm({
    initialValues: {
      password: '',
      password2: '',
      requestId,
      token: ''
    },
    initializeField: createFieldInitializer(UpdatePasswordFormSchema),
    validateField: createFieldValidator(UpdatePasswordFormSchema),
    validate: createFormValidator(UpdatePasswordFormSchema),
    onSubmit: postUpdatePassword,
    onSuccess () {
      navigate(getPasswordResetSuccessLink())
    }
  })

  return (
    <Page>
      <Stack w="100%" maw={450}>
        <Card shadow="sm" p="xl">
          <SmartForm context={form}>
            <Stack>
              <PageTitle
                size="h2"
                title={intl.formatMessage({
                  id: 'password_change',
                  defaultMessage: 'Changement de mot de passe'
                })}
              />
              <Text>
                <FormattedMessage
                  id="enter_password_reset_code"
                  defaultMessage="Entrez le code de vérification qui vous a été envoyé, puis choisissez un nouveau mot de passe sécurisé."
                />
              </Text>
              <Box>
                <FormField
                  autoComplete="off"
                  label={intl.formatMessage({
                    id: 'verification_code',
                    defaultMessage: 'Code de vérification'
                  })}
                  name="token"
                />
                <Text size="sm">
                  <AnchorLink to={getPasswordResetLink()}>
                    <FormattedMessage
                      id="password_reset_code_not_received"
                      defaultMessage="Vous n'avez pas reçu le code de vérification ?"
                    />
                  </AnchorLink>
                </Text>
              </Box>
              <FormField
                autoComplete="new-password"
                label={intl.formatMessage({
                  id: 'new_password',
                  defaultMessage: 'Nouveau mot de passe'
                })}
                name="password"
                render={PasswordInput}
              />
              <FormField
                autoComplete="off"
                label={intl.formatMessage({
                  id: 'repeat_password',
                  defaultMessage: 'Répétez le mot de passe'
                })}
                name="password2"
                render={PasswordInput}
              />

              {/*
              {form.submitError && form.submitError.body &&
              form.submitError.body.error && form.submitError.body.error.code === 'weak-password'
                ? <ul className="list-unstyled">
                  {Object.values(form.submitError.body.error.details)
                    .map((error) => (
                      <li className="text-danger">{error}</li>
                    ))}
                </ul>
                : null}
                */}

              <ButtonGroup>
                <FormSubmitButton
                  fullWidth
                  size="lg"
                  label={intl.formatMessage({
                    id: 'update_my_password',
                    defaultMessage: 'Modifier mon mot de passe'
                  })}
                />
              </ButtonGroup>
            </Stack>
          </SmartForm>
        </Card>
        <Text ta="center">
          <AppVersion />
        </Text>
      </Stack>
    </Page>
  )
}

export default UpdatePasswordFormPage
